export enum IngredientAction {
  ADD,
  REMOVE,
  RESTORE,
  SELECT_HALF,
  ADD_QUALIFIER,
  REMOVE_QUALIFIER,
  RESET,
}
